//@ts-ignore
import React from "react";
import ReactPlayer from "react-player";
import { useVideoValidContext } from "../../utils/hooks";

const VideoPlayer = React.forwardRef((props: any, ref) => {
  const { width = "100%", height = "100%", userGenerated, ...rest } = props;

  const videoValidContext = useVideoValidContext() as {
    updateVideoValid: (data: any) => void;
  };
  const updateVideoValid = videoValidContext?.updateVideoValid;
  const checkVideoStatus = (status: string) => {
    if (userGenerated && updateVideoValid) {
      updateVideoValid(status);
    }
  };

  return (
    <ReactPlayer
      ref={ref}
      width={width}
      height={height}
      onReady={() => checkVideoStatus("ready")}
      onError={() => checkVideoStatus("error")}
      {...rest}
    />
  );
});

export default VideoPlayer;
